/* eslint-disable react-hooks/exhaustive-deps */
import { useAppSelector } from 'redux/hooks';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { ImpressionAnalytics } from '@doda/common/src/components/Analytics/ImpressionAnalytics';
import {
  numOfVideoSelector,
  resultCountSelector,
} from 'redux/features/jobList';
import {
  measureImpressionMatchJobListAA,
  measureImpressionMatchJobListGA,
} from '../logics/analytics';

export const PageImpression = () => {
  const query = useAppSelector(appQueryParamsSelector);
  const resultCount = useAppSelector(resultCountSelector);
  const primeCount = useAppSelector(numOfVideoSelector);

  return (
    <ImpressionAnalytics
      adobe={() =>
        measureImpressionMatchJobListAA({ query, resultCount, primeCount })
      }
      google={() => measureImpressionMatchJobListGA(query)}
    />
  );
};
